import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setLatestQFRequestId', function (latestQFRequestId) {
    getStore().latestQFRequestId = latestQFRequestId;
});
//# sourceMappingURL=setLatestQFRequestId.js.map